module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/ant-mobile-english.519a164e.jpg";